import SearchField from "./SearchField";
import SearchTrackResultList from "./SearchTrackResultList";
import styled from "styled-components";
import {useEffect, useState} from "react";
import {searchTrack} from "../../services/track-searcher";
import {TTrack} from "../../types";
import {ErrorMessage} from "../ErrorMessage";
import {Title} from "../Title";
import {Subtitle} from "../Subtitle";

export type SearchModuleProps = {
    setLastSearchActionDatetime: (newValue: Date) => void,
};

export const SearchModuleContainer = styled.div`
    color: ${props => props.theme.palette.common.black};
    text-align: center;
    background-color: ${props => props.theme.palette.common.gray['100']};
    min-height: 30vh;
    border-bottom: ${props => props.theme.palette.common.gray['300']} 2px solid;
`;


function SearchModule(props: SearchModuleProps) {
    const {setLastSearchActionDatetime} = props;

    const [query, setQuery] = useState<string>("");
    const [hasAPIError, setHasAPIError] = useState<boolean>(false);
    const [hasMadeFirstSearch, setHasMadeFirstSearch] = useState<boolean>(false);
    const [isSearching, setIsSearching] = useState<boolean>(false);
    const [tracks, setTracks] = useState<Array<TTrack>>([]);

    useEffect(() => {

        const debounceTimer = setTimeout(() => {
            if (!query) return;

            setIsSearching(true);
            setHasAPIError(false);

            searchTrack(query).then(result => {
                setTracks(result);
                setHasAPIError(false);
            }).catch(() => {
                setHasAPIError(true);
            }).finally(() => {
                setIsSearching(false);
                setHasMadeFirstSearch(true);
            });
        }, 500);

        return () => clearTimeout(debounceTimer);

    }, [query]);

    return (
        <SearchModuleContainer>
            <Title>Search for Music on Spotify</Title>
            <Subtitle>Find a track on Spotify by name</Subtitle>
            <SearchField query={query} setQuery={setQuery}/>
            {hasAPIError && (<ErrorMessage>Oops. Something went wrong, please try again.</ErrorMessage>)}
            <SearchTrackResultList
                query={query}
                tracks={tracks}
                hasMadeFirstSearch={hasMadeFirstSearch}
                isSearching={isSearching}
                onClick={() => {
                    setLastSearchActionDatetime(new Date())
                }}
            />
        </SearchModuleContainer>
    );
}

export default SearchModule;
